import React, { useState, useMemo } from 'react';
import { POSITIONS } from '../api/rangesApi';
import '../styles/RangeList.css';

const RangeList = ({ ranges, selectedId, onSelect, onDelete, onClone, onNew, readOnly }) => {
  const [collapsedGroups, setCollapsedGroups] = useState({});

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Группировка по позициям
  const groupedRanges = useMemo(() => {
    const groups = {};
    
    // Инициализируем группы в порядке позиций
    POSITIONS.forEach(pos => {
      groups[pos] = [];
    });
    groups['Другое'] = [];
    
    // Распределяем диапазоны по группам
    ranges.forEach(range => {
      const pos = range.position;
      if (groups[pos]) {
        groups[pos].push(range);
      } else {
        groups['Другое'].push(range);
      }
    });
    
    // Убираем пустые группы
    return Object.entries(groups).filter(([_, items]) => items.length > 0);
  }, [ranges]);

  const toggleGroup = (position) => {
    setCollapsedGroups(prev => ({
      ...prev,
      [position]: !prev[position]
    }));
  };

  return (
    <div className="range-list">
      <div className="range-list-header">
        <h3>Сохранённые диапазоны</h3>
        {!readOnly && onNew && (
          <button className="new-range-btn" onClick={onNew}>
            <span>+</span> Новый
          </button>
        )}
      </div>
      
      <div className="range-list-items">
        {ranges.length === 0 ? (
          <div className="empty-list">
            <span className="empty-icon">📋</span>
            <p>Нет сохранённых диапазонов</p>
          </div>
        ) : (
          groupedRanges.map(([position, items]) => (
            <div key={position} className="position-group">
              <div 
                className="group-header"
                onClick={() => toggleGroup(position)}
              >
                <span className={`group-arrow ${collapsedGroups[position] ? 'collapsed' : ''}`}>▼</span>
                <span className="group-name">{position}</span>
                <span className="group-count">{items.length}</span>
              </div>
              
              {!collapsedGroups[position] && (
                <div className="group-items">
                  {items.map((range) => (
                    <div
                      key={range.id}
                      className={`range-list-item ${selectedId === range.id ? 'selected' : ''}`}
                      onClick={() => onSelect(range.id)}
                    >
                      <div className="item-main">
                        <span className="item-name">{range.name || 'Без названия'}</span>
                        <div className="item-tags">
                          {range.vs_positions && range.vs_positions.length > 0 && (
                            <span className="item-vs-position">
                              vs {range.vs_positions.length <= 3 
                                ? range.vs_positions.join(', ') 
                                : `${range.vs_positions.slice(0, 2).join(', ')}+${range.vs_positions.length - 2}`}
                            </span>
                          )}
                          {(range.stack_from !== undefined || range.stack_to !== undefined) && (
                            <span className="item-stack">
                              {range.stack_from || 0}-{range.stack_to || 100} BB
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="item-meta">
                        <span className="item-date">{formatDate(range.updated_at)}</span>
                        {!readOnly && (
                          <div className="item-actions">
                            {onClone && (
                              <button 
                                className="clone-btn"
                                onClick={(e) => { e.stopPropagation(); onClone(range.id); }}
                                title="Клонировать"
                              >
                                📋
                              </button>
                            )}
                            {onDelete && (
                              <button 
                                className="delete-btn"
                                onClick={(e) => { e.stopPropagation(); onDelete(range.id); }}
                                title="Удалить"
                              >
                                🗑️
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                      {range.comment && (
                        <div className="item-comment">{range.comment}</div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RangeList;

